export default __webpack_public_path__ + "static/media/tenant.b6b23459.svg";